import React from 'react';

const LoadingSpinner = ({ size = 'medium', className = '', fullScreen = false }) => {
  const sizeClasses = {
    small: 'h-6 w-6',
    medium: 'h-10 w-10',
    large: 'h-16 w-16'
  };

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-80 z-50">
        <div className={`${sizeClasses[size]} relative`}>
          {/* Static background */}
          <div className="absolute inset-0 border-2 border-gray-200 rounded-full"></div>
          {/* Animated part */}
          <div 
            className="absolute inset-0 border-2 border-transparent border-t-orange-500 rounded-full animate-spin"
          ></div>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center min-h-screen ${className}`}>
      <div className={`${sizeClasses[size]} relative`}>
        {/* Static background */}
        <div className="absolute inset-0 border-2 border-gray-200 rounded-full"></div>
        {/* Animated part */}
        <div 
          className="absolute inset-0 border-2 border-transparent border-t-orange-500 rounded-full animate-spin"
        ></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;